import { Cookies } from 'react-cookie-consent'

export const consentGiven = (): boolean => {
  const consentCookie = Cookies.get('CookieConsent')
  return consentCookie && consentCookie === 'true'
}
